module.exports = __webpack_public_path__ + "static/media/search student.647e9383.svg";